import { useQuery } from "@tanstack/react-query";
import { listAuditLogs, type AuditFilters } from "./api";

export function useAuditLogs(params: AuditFilters) {
  return useQuery({
    queryKey: ["audit-logs", params],
    queryFn: () => listAuditLogs(params),
    placeholderData: (prev) => prev,
  });
}
